import React, { useState } from 'react';
import { usePathname } from 'expo-router';
import { useAuthStore } from '@/store/auth';
import { businessApi } from '@/lib/api/business';
import { useBusinessResource } from './useBusinessResource';
import { BusinessWorkspaceContext as Context, workspaceFromPath } from './BusinessWorkspaceContext';

function Directory({ accountId, api, children }) {
  const pathname = usePathname(), [revision, setRevision] = useState(0);
  const billingCompanyId = useAuthStore(state => state.user?.business?.id);
  const current = () => useAuthStore.getState().user?.id === accountId && !!useAuthStore.getState().token;
  const directory = useBusinessResource(async options => {
    const request = { isRequestCurrent: () => options.isRequestCurrent() && current() };
    const access = await api.access(request);
    if (!access.enabled) return [];
    return (await api.list(request)).workspaces;
  }, [accountId, api, revision, billingCompanyId]);
  const workspaces = directory.value || [], workspaceId = workspaceFromPath(pathname);
  return <Context.Provider value={{ api, accountId, current, workspaces, workspaceId, directory,
    workspace: workspaces.find(item => item.id === workspaceId), revision, changed: () => setRevision(value => value + 1) }}>
    {children}
  </Context.Provider>;
}
export default function BusinessWorkspaceProvider({ children, api = businessApi }) {
  const accountId = useAuthStore(state => state.user?.id), token = useAuthStore(state => state.token);
  if (!accountId || !token) return <Context.Provider value={null}>{children}</Context.Provider>;
  // All directory state is discarded synchronously when the account changes.
  return <Directory key={accountId} accountId={accountId} api={api}>{children}</Directory>;
}
